<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1 class="h1">Factures</h1>
      </b-col>
      <b-col>
        <b-form-group
          label-class="font-weight-bold"
          label="Fecha Inicial"
          label-for="dp-fechaIni"
        >
          <b-form-datepicker
            id="dp-fechaIni"
            v-model="fechaInicio"
            required
            locale="ES"
            today-button
            reset-button
            close-button
            class="mb-2"
            @input="GetFacturas()"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label-class="font-weight-bold"
          label="Fecha Final"
          label-for="dp-fechaFin"
        >
          <b-form-datepicker
            id="dp-fechaFin"
            v-model="fechaFin"
            required
            locale="ES"
            today-button
            reset-button
            close-button
            class="mb-2"
            @input="GetFacturas()"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col class="col text-right">
        <b-button class="p-2 m-2" variant="outline-success">
          <router-link
            :to="{
              name: 'FacturaAdd',
            }"
            class="icon"
          >
            <b-icon icon="plus"></b-icon>
            Facturar
          </router-link>
        </b-button>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col lg="6" class="my-1">
        <b-form-group
          label="Sort"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="sortBySelect"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-select
              v-model="sortBy"
              id="sortBySelect"
              :options="sortOptions"
              class="w-75"
            >
              <template v-slot:first>
                <option value="">-- none --</option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc"
              size="sm"
              :disabled="!sortBy"
              class="w-25"
            >
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6"></b-col>
      <!-- //Canvi de Fila -->
      <b-col lg="6">
        <b-form-group
          label="Filtro: "
          label-cols-sm="2"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="busqueda por num factura.."
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6" class="my-1">
        <b-form-group
          label="Filter On"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          description="Leave all unchecked to filter on all data"
          class="mb-0"
        >
          <b-form-checkbox-group v-model="filterOn" class="mt-1">
            <b-form-checkbox value="xxxx">Factura</b-form-checkbox>
            <b-form-checkbox value="xxxx">Clente</b-form-checkbox>
            <b-form-checkbox value="isActive">Esta Activo</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <b-table
      :tbody-tr-class="rowClass"
      primary-key="facturas.identifier"
      :items="facturas"
      :fields="fieldsFacturas"
      hover
      small
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      @filtered="onFiltered"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
    >
      <template v-slot:cell(numFact)="data">
        <router-link
          :to="{
            name: 'FacturaDetails',
            params: { factura: data.item },
          }"
        >
          {{ data.item.serieIdentifier }}-{{ data.item.numFact }}
        </router-link>
      </template>
      <template v-slot:cell(acciones)="data">
        <router-link
          :to="{
            name: 'FacturaEdit',
            params: { factura: data.item },
          }"
          class="icon"
        >
          <b-icon icon="pen" variant="info"></b-icon>
        </router-link>
        <router-link
          :to="{
            name: 'FacturaDelete',
            params: { factura: data.item },
          }"
          class="icon"
        >
          <b-icon icon="trash" variant="danger"></b-icon>
        </router-link>
      </template>
      <template v-slot:cell(doc)="data">
        <b-icon icon="file-earmark-arrow-down" class="hover-icon" @click="openPdf(data.item.archivo)"></b-icon>
      </template>
      <template v-slot:cell(precioBase)="data">
        {{ data.item.precioBase.toFixed(2) }} €
      </template>
      <template v-slot:cell(impuestoIVA)="data">
        {{ data.item.impuestoIVA.toFixed(2) }} €
      </template>
      <template v-slot:cell(totalFactura)="data">
        {{ data.item.totalFactura.toFixed(2) }} €
      </template>
      <template v-slot:cell(isPagada)="data">
        <template v-if="data.item.isPagada">
          <span>&check;</span>
        </template>
      </template>
      <template v-slot:custom-foot="data">
        <b-tr>
          <b-td><b>TOTALES</b></b-td>
          <b-td
            ><b>{{ data.items.length }}</b>
          </b-td>
          <b-td></b-td>
          <b-td
            ><b
              >{{
                data.items.reduce((a, c) => a + c.precioBase, 0).toFixed(2)
              }}
              €</b
            ></b-td
          >
          <b-td></b-td>
          <b-td
            ><b
              >{{
                data.items.reduce((a, c) => a + c.impuestoIVA, 0).toFixed(2)
              }}
              €</b
            ></b-td
          >
          <b-td
            ><b
              >{{
                data.items.reduce((a, c) => a + c.totalFactura, 0).toFixed(2)
              }}
              €</b
            ></b-td
          >
        </b-tr>
      </template>
    </b-table>
    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per pàgina"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>


<style scoped>
.hover-icon {
  cursor: pointer;
  transition: transform 0.2s, fill 0.2s;
  fill: #1daf17; /* Color inicial del icono */
}

.hover-icon:hover {
  transform: scale(1.2);
  fill: #2ce91b; /* Cambia el color de llenado aquí */
}
</style>


<script>
import DataAccess from '@/Services/DataAccess.js'
import moment from 'moment'

export default {
  data () {
    return {
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 20,50,100],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      facturas: [],
      fieldsFacturas: [
        {
          key: 'numFact',
          label: 'Nº Fact',
          sortable: true
        },
        {
          key: 'doc',
          label: 'Doc'
        },
        {
          key: 'fechaFactura',
          label: 'Fecha Fact.',
          sortable: true,
          sortDirection: 'desc',
          formatter: (value) => {
            return moment(value).format('DD/MM/YYYY')
          }
        },
        {
          key: 'clienteIdentifier',
          label: 'Cliente',
          sortable: true,
          formatter: (value, key, item) => {
            return item.cliente.nombre
          },
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'precioBase',
          label: 'Base'
        },
        {
          key: 'descuentoFactura',
          label: 'Dto(%)'
        },
        {
          key: 'impuestoIVA',
          label: 'IVA'
        },
        {
          key: 'totalFactura',
          label: 'Total Fact'
        },
        {
          key: 'fechaVencimiento',
          label: 'Fecha Vto.',
          sortable: true,
          sortDirection: 'desc',
          formatter: (value) => {
            return moment(value).format('DD/MM/YYYY')
          }
        },
        {
          key: 'isPagada',
          label: 'Cobrada'
        },
        {
          key: 'acciones',
          label: 'Acciones'
        }
      ],
      fechaInicio: moment().year() + '-01-01',
      fechaFin: moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fieldsFacturas
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created () {
    this.GetFacturas()
  },
  methods: {
    async GetFacturas () {
      (async () => {
        var url =
            '/api/facturas/' +
            this.fechaInicio +
            '/' +
            this.fechaFin.toString() +
            '/true'
        await DataAccess.getData(url)
          .then((response) => {
            this.facturas = response.data
            this.totalRows = this.facturas.length
            this.loading = false
          })
          .catch((error) => {
            console.log('ERROR: ', error)
          })
      })()
    },
    rowClass (item, type) {
      if (
        type === 'row' &&
          Date.parse(item.fechaVencimiento) < Date.now() &&
          !item.isPagada
      ) {
        return 'table-danger'
      }
    },
    makeToast (toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openPdf(pdfUrl) {
      if (!pdfUrl) {
        this.makeToast('b-toaster-top-right', 'danger', 'Factura no encontrada', 'No existe el PDF para esta factura', true)
        return
      }      
      // Assuming this.factura is the current factura object
      // and it has a property 'identifier' that you want to use in the URL
      window.open(pdfUrl, '_blank');
    }

  }
}
</script>
